// FILE: nameColor.ts
// Purpose: Derive a stable colour from a name, so the same item is always the same colour without storing one.
// Exports: `nameToHue`.

/**
 * Stable hue 0–359 from a string, for consistent per-item colors.
 *
 * The point is determinism, not distribution: two clients, two sessions and
 * two surfaces must all draw the same person (or the same plugin) in the same
 * colour, and none of them has anywhere to persist a choice. A hash of the
 * name is the cheapest thing that satisfies that.
 *
 * Collisions are accepted. With 360 hues and a handful of names on screen,
 * two neighbours occasionally landing on the same colour is a cosmetic event,
 * whereas a colour that changes on reload is a bug people report.
 */
export function nameToHue(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = name.charCodeAt(i) + ((h << 5) - h);
  }
  return Math.abs(h) % 360;
}
